import React, { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import GetRequest from "../Services/APIRequest";
import Loading from "../Components/Loading";
import Error from "../Components/Error";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const VoucherDetails = () => {
  const { Id } = useParams();
  const { data, error, isLoaded } = GetRequest(
    `/Account/GetVoucherDetails/${Id}`,
  );
  const voucherRef = useRef();
  const userType = localStorage.getItem("userType");

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "2-digit",
      })
      .replace(",", "");
  };

  const downloadPDF = () => {
    html2canvas(voucherRef.current).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        210,
        (canvas.height * 210) / canvas.width,
      );
      pdf.save(`Voucher_${data.result.voucherNumber}.pdf`);
    });
  };

  if (error) return <Error data="Error loading voucher details" />;
  if (!isLoaded) return <Loading />;

  const inventoryDetails = JSON.parse(data.result.inventoryDetailsJSON || "[]");
  const ledgerDetails = JSON.parse(data.result.ledgerDetailsJSON || "[]");
  const costCentreDistributions = data.result.costCentreDistributions || [];

  return (
    <div className="container mt-4" ref={voucherRef}>
      <div className="d-flex justify-content-between mb-3">
        <h5 className="text-blue">Voucher Details</h5>
        <div>
          {
            <a
              href={`https://dpapi.boosterparis.in/ReportsView/GenerateDownloadVoucher/${data.result.id}/${data.result.voucherType}/${data.result.voucherType}_${data.result.voucherNumber}.pdf`}
              target="_blank"
            >
              <button type="button" className="btn btn-primary btn-block100">
                <i className="fa fa-download"></i> Download
              </button>
            </a>
          }
          <Link to="/" className="btn btn-success me-2">
            Home
          </Link>
          <Link to="/AccountSummary" className="btn btn-success">
            Back
          </Link>
        </div>
      </div>

      <div className="card p-3 mb-4">
        <div className="row">
          <div className="col-md-6">
            <b>Voucher Type:</b> {data.result.voucherType}
          </div>
          <div className="col-md-6">
            <b>Voucher Number:</b> {data.result.voucherNumber}
          </div>
          <div className="col-md-6">
            <b>Date:</b> {formatDate(data.result.voucherDate)}
          </div>
          <div className="col-md-6">
            <b>Original Inv No:</b> {data.result.OriginalInvNo || "N/A"}
          </div>
          <div className="col-md-6">
            <b>Party Name:</b> {data.result.partyName}
          </div>
          <div className="col-md-6">
            <b>Company Name:</b> {data.result.CompanyName}
          </div>
          <div className="col-md-6">
            <b>Amount:</b> Rs {data.result.amount}
          </div>
          <div className="col-md-6">
            <b>Total Dr Amount:</b> Rs {data.result.totalDrAmount}
          </div>
          <div className="col-md-6">
            <b>Total Cr Amount:</b> Rs {data.result.totalCrAmount}
          </div>
          {userType === "BPUser" && (
            <div className="col-md-6">
              <b>Narration:</b> {data.result.narration || "N/A"}
            </div>
          )}
        </div>
      </div>

      <div className="card p-3 mb-4">
        <h6 className="text-blue">Inventory Details</h6>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Amount</th>
              <th>Rate</th>
              <th>Quantity</th>
              <th>Unit</th>
            </tr>
          </thead>
          <tbody>
            {inventoryDetails.map((item, index) => (
              <tr key={index}>
                <td>{item.item_name}</td>
                <td>Rs {item.amount}</td>
                <td>Rs {item.rate}</td>
                <td>{item.quantity}</td>
                <td>{item.unit}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="card p-3 mb-4">
        <h6 className="text-blue">Ledger Details</h6>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Ledger Name</th>
              <th>Amount</th>
              <th>Dr/Cr</th>
            </tr>
          </thead>
          <tbody>
            {ledgerDetails.map((ledger, index) => (
              <tr key={index}>
                <td>{ledger.ledger_name}</td>
                <td>Rs {ledger.ledger_amt}</td>
                <td>{ledger.dr_cr}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="card p-3 mb-4">
        <h6 className="text-blue">Cost Centre Distributions</h6>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Centre Name</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {costCentreDistributions.map((centre, index) => (
              <tr key={index}>
                <td>{centre.cname}</td>
                <td>Rs {centre.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VoucherDetails;
